/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { Box, Stack } from '@mui/material';
import CustomBox from 'components/cmn/CustomBox';
import OneButtonDialog from 'components/cmn/OneButtonDialog';
import { useAppDispatch } from 'store';
import { closeDialog } from 'store/dialog/dialogSlice';

interface INotFountProjectIdDialogProps {
  errorInfo: any;
}
function NotFoundProjectIdDialog({ errorInfo }: INotFountProjectIdDialogProps): JSX.Element {
  const dispatchApp = useAppDispatch();
  const handleClose = async () => {
    dispatchApp(closeDialog());
    // TODO
    console.log('메인 리스트 이동필요');
  };
  return (
    <OneButtonDialog
      confirmTitle="확인"
      handleConfirm={handleClose}
      content={
        <CustomBox
          title={
            <Stack direction="column" justifyContent="center" alignItems="center">
              <Box>존재하지 않는 프로젝트 ID 또는 참여코드입니다.</Box>
              <Stack direction="column" justifyContent="flex-start" alignItems="center">
                <Box>{`(${errorInfo?.response?.data?.message})` || ''}</Box>
              </Stack>
            </Stack>
          }
          typography="s15w400"
          color="mind.black.A0"
        />
      }
    />
  );
}

export default memo(NotFoundProjectIdDialog);
